import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Map, Marker, GoogleApiWrapper, Polyline } from "google-maps-react";

import "./mapcomp.css";

// function MapComp(props) {
//   const [mapData, setMapData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [polygon, setPolygon] = useState([]);
//   const [center, setCenter] = useState({});
//   const [bounds, setBounds] = useState();

//   useEffect(() => {
//     if (!props.mapData.londing) {
//       getCoordinates(props.mapData.data);
//     }
//     setMapData(props.mapData.data);
//     setLoading(props.mapData.loading);
//   }, [props]);

//   const getCoordinates = (data) => {
//     let polygon = [];
//     let center = {};
//     // let points =
//     if (data) {
//       data.forEach((element) => {
//         // let coordinates = []
//         polygon.push({ lat: element.lat, lng: element.lng });
//         if (element.locType === "Origin") {
//         }
//       });
//       let bound = new props.google.maps.LatLngBounds();
//       for (var i = 0; i < polygon.length; i++) {
//         bound.extend(polygon[i]);
//         if (i === 1) {
//           center = polygon[i];
//         }
//       }
//       setCenter(center);
//       setPolygon(polygon);
//       setBounds(bound);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="loadingClass">
//         <CircularProgress size="1.5rem" />
//       </div>
//     );
//   }

//   return (
//     <div className="shipmentDetailsComp">
//       <Map google={props.google} zoom={14} center={center} bounds={bounds}>
//         {mapData.map((element) => {
//           return (
//             <Marker
//               icon={{
//                 url: element.iconPath,
//                 scaledSize: new window.google.maps.Size(30, 35),
//               }}
//               title={`${element.locType}/${element.locName}`}
//               position={{ lat: element.lat, lng: element.lng }}
//             />
//           );
//         })}
//         <Polyline
//           path={polygon}
//           strokeColor="#0000FF"
//           strokeOpacity={0.8}
//           strokeWeight={2}
//         />
//       </Map>
//     </div>
//   );
// }

function MapComp(props) {
  console.log(props);
  const [coordinate, setCoordinate] = useState([]);
  const [polyline, setPolyline] = useState([]);

  const [bounds, setBounds] = useState(new props.google.maps.LatLngBounds());

  console.log("This is the map component.");

  useEffect(() => {
    setCoordinate(props.mapData);
    const arr = [];
    let bound = new props.google.maps.LatLngBounds();

    props.mapData.map((ele, index) => {
      ele.path.map((item) => {
        const obj = {
          lat: parseFloat(item[0]),
          lng: parseFloat(item[1]),
        };
        arr.push(obj);

        bound.extend(obj);
      });

      // if (index != 2) {

      // }
    });
    setBounds(bound);
    setPolyline([...arr]);
  }, [props]);

  // console.log("polyline", polyline, coordinate, props, bounds);

  return (
    <Map
      google={props.google}
      style={{ width: "100%", height: "100%", position: "absolute" }}
      className={"map"}
      bounds={bounds}
      zoom={14}
    >
      {polyline.map((item, index) => {
        if (index === 0 || index === polyline.length - 1) {
          return (
            <Marker
              position={item}
              title={`lat=${item.lat}, lng=${item.lng}`}
            />
          );
        }
      })}
      {Object.keys(props.currentPin).length && (
        <Marker title="Current Location" position={props.currentPin} />
      )}

      {/* {!props.loading &&
          coordinate.length != 0 &&
          coordinate.map((item) => {
            const title = `Country: ${item.country} \nState: ${item.state}\nName: ${item.name} \nLoco Code: ${item.locode}`;
            return (
              <Marker
                // title={title}
                // name={"SOMA"}
                position={{ lat: parseFloat(item.lat), lng: item.lng }}
              />
            );
          })} */}
      {polyline.length != 0 && !props.loading && (
        <Polyline
          path={polyline}
          strokeColor="#0000FF"
          strokeOpacity={0.8}
          strokeWeight={2}
          fillColor="#0000FF"
          fillOpacity={1}
          options={{
            strokeColor: "#0a2d44",
            strokeOpacity: 0.75,
            strokeWeight: 2,
            icons: [
              {
                icon: {
                  path: props.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                  strokeOpacity: 0,
                  fillColor: "#0a2d44",
                  fillOpacity: 1.0,
                  scale: 4,
                },
                repeat: "80px",
              },
            ],
          }}
        />
      )}
    </Map>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDpfWeLTpZm0lhuv7_s-8cvKv_8sxJUHD0",
})(MapComp);
